import React from 'react'
import {
  IBaseProps,
  IBasePropsWithSlots,
  ICallback,
  ITokenInfo,
  ORDER_ACTION_TYPE
} from '@did/types'
import { NotFoundType } from './components'

export interface IMyAccountList extends IBasePropsWithSlots {
  loading?: boolean
  balance?: string
  NotFound: NotFoundType
}

export type MyAccountListType = React.FC<IMyAccountList>

export interface ISendContentProps
  extends ICallback<
      { txHashLink: string; txHash: string; actionType: ORDER_ACTION_TYPE },
      any
    >,
    IBaseProps {
  balance: string
}

export type SendContentType = React.FC<ISendContentProps>

export interface IActivateInfoProps
  extends ICallback<
      { txHashLink: string; txHash: string; actionType: ORDER_ACTION_TYPE },
      any
    >,
    IBaseProps {
  transitBalance: string
}

export type ActivateInfoType = React.FC<IActivateInfoProps>

export interface IAvailableBalanceProps
  extends ICallback<{ balance: string }, void>,
    IBaseProps {
  onSendClick?: () => void
  onReceiveClick?: () => void
  ActivateInfo?: ActivateInfoType
  availableBalance?: string
  balanceUSD?: string
  transitBalance?: string
}

export type AvailableBalanceType = React.FC<IAvailableBalanceProps>

export interface IActionDialogProps
  extends ICallback<
      { txHashLink: string; txHash: string; actionType: ORDER_ACTION_TYPE },
      any
    >,
    IBaseProps {
  receiveShow?: boolean
  sendShow?: boolean
  onReceiveShowChange?: (show: boolean) => void
  onSendShowChange?: (show: boolean) => void
  availableBalance: string
}

export type ActionDialogType = React.FC<IActionDialogProps>

export interface IRecordListList extends IBasePropsWithSlots {
  loading?: boolean
  balance?: string
  filter?: number
  NotFound: NotFoundType
}

export type RecordListType = React.FC<IRecordListList>

export interface IDidPointBalanceProps extends IBaseProps {
  balance?: string
}

export type DidPointBalanceType = React.FC<IDidPointBalanceProps>

export interface IDasBalanceInsufficientDialogProps extends IBaseProps {
  registrationFees: string
  showing?: boolean
  onClose?: () => void
}

export type DasBalanceInsufficientDialogType =
  React.FC<IDasBalanceInsufficientDialogProps>

export interface IPaymentConfirmProps extends IBaseProps {
  tokenList: ITokenInfo[]
  onTokenChange?: (token: ITokenInfo) => void
  selectedToken?: ITokenInfo
  fiatTermsLink?: string
  stripeServiceFee?: string
  stripePaidAmount?: string
  paidTokenAmount?: string
  showAll?: boolean
  onPay?: () => Promise<any>
  payLoading?: boolean
}

export type PaymentConfirmType = React.FC<IPaymentConfirmProps>

export interface IWithdrawListProps extends IBaseProps {
  list: any[]
}

export type WithdrawListType = React.FC<IWithdrawListProps>

export interface ISignatureErrorDialogProps extends IBaseProps {
  showing?: boolean
  onClose?: () => void
}

export type SignatureErrorDialogType = React.FC<ISignatureErrorDialogProps>
